module.exports = __webpack_public_path__ + "static/media/community-gardens-gallery-6-xl.d9910808.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/community-gardens-gallery-6-xl.jpg
// module id = 393
// module chunks = 12